/**
 * Actions
 */

import {
  FORM_CLEAR,
  FORM_REGISTER_INPUTS,
  FORM_INPUT_CHANGE,
  FORM_INPUT_FOCUS,
  FORM_INPUT_BLUR,
  FORM_VALIDATE_REQUEST,
  FORM_VALIDATE_PASS,
  FORM_VALIDATE_FAIL,
  FORM_SUBMIT_REQUEST,
  FORM_SUBMIT_FAIL,
  FORM_BUTTON_PASS,
  FORM_BUTTON_FAIL
} from 'redux-types/form'

/**
 * Reducer
 */

export default function reducer (state = {}, action) {
  const { form_uid } = action

  switch (action.type) {
    case FORM_CLEAR:
      return Object.keys(state).reduce((partial, form_id) => ({
        ...partial,
        [form_id]: {
          ...state[form_uid],
          progress: null,
          inputs: state[form_id].inputs
            .map((el) => {
              return {
                ...el,
                focused: false,
                invalid: false,
                valid: false,
                disabled: false,
                message: ''
              }
            })
        }
      }), {})

    case FORM_REGISTER_INPUTS:
      return {
        ...state,
        [action.form_uid]: {
          ...state[form_uid],
          progress: '',
          inputs: action.inputs.map((input) => {
            return {
              ...input,
              valid: false,
              invalid: false,
              focused: false,
              disabled: false
            }
          })
        }
      }

    case FORM_INPUT_CHANGE:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: '',
          inputs: state[form_uid].inputs.map((input) => {
            if (input.name === action.data.name) {
              return {
                ...input,
                message: '',
                valid: false,
                invalid: false
              }
            }
            return input
          })
        }
      }

    case FORM_INPUT_FOCUS:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: '',
          inputs: state[form_uid].inputs.map((input) => {
            if (input.name !== action.data.name) return input
            return {
              ...input,
              message: '',
              focused: true
            }
          })
        }
      }

    case FORM_INPUT_BLUR:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: '',
          inputs: state[form_uid].inputs.map((input) => {
            if (input.name !== action.data.name) return input
            return {
              ...input,
              message: '',
              valid: false,
              invalid: false,
              focused: false
            }
          })
        }
      }

    case FORM_VALIDATE_REQUEST:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: '',
          inputs: state[form_uid].inputs.map((input) => {
            if (input.name === action.name) {
              return {
                ...input,
                message: '',
                valid: false,
                invalid: false,
                focused: false,
                disabled: false
              }
            }
            return input
          })
        }
      }

    case FORM_VALIDATE_PASS:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: '',
          inputs: state[form_uid].inputs.map((input) => {
            if (input.name === action.data.name) {
              return {
                ...input,
                message: '',
                invalid: false,
                valid: true
              }
            }
            return input
          })
        }
      }

    case FORM_VALIDATE_FAIL:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: 'disabled',
          inputs: state[form_uid].inputs.map((input) => {
            if (input.name === action.data.name) {
              return {
                ...input,
                valid: false,
                invalid: true,
                message: action.error[input.name]
              }
            }
            return input
          })
        }
      }

    case FORM_SUBMIT_REQUEST:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: 'loading'
        }
      }

    case FORM_SUBMIT_FAIL:
      const errors = action.error || {}
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: 'error',
          inputs: state[form_uid].inputs.map((input) => {
            var errorMessage = errors[input.name]
            return errorMessage ? ({
              ...input,
              valid: false,
              invalid: true,
              message: errorMessage
            }) : ({
              ...input,
              valid: true,
              invalid: false,
              message: ''
            })
          })
        }
      }

    case FORM_BUTTON_PASS:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: 'success'
        }
      }

    case FORM_BUTTON_FAIL:
      return {
        ...state,
        [form_uid]: {
          ...state[form_uid],
          progress: 'error'
        }
      }

    default:
      return state
  }
}
